import { render, staticRenderFns } from "./ArticleTagsModule.vue?vue&type=template&id=f42eae60&"
import script from "./ArticleTagsModule.ts?vue&type=script&lang=ts&"
export * from "./ArticleTagsModule.ts?vue&type=script&lang=ts&"
import style0 from "./ArticleTagsModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports